const getTransactionClass = (transaction_type) => {
    if (transaction_type === 'expense') {
        return 'error-color';
    } else if (transaction_type === 'income') {
        return 'success-color';
    } else if (transaction_type === 'transfer') {
        return 'theme-color';
    }
};

const getTransactionImage = (id) => {
    if (id === null || id === undefined || id === 0) {
        return '/assets/images/svg/transfer-v3.svg';
    }
    if (id === 1) {
        return '/assets/images/svg/3.svg';
    } else if (id === 2) {
        return '/assets/images/svg/transportation-v3.svg';
    } else if (id === 3) {
        return '/assets/images/svg/entertainment.svg';
    } else if (id === 4) {
        return '/assets/images/svg/shopping.svg';
    } else if (id === 5) {
        return '/assets/images/svg/housing.svg';
    } else if (id === 6) {
        return '/assets/images/svg/vehicle.svg';
    } else if (id === 7) {
        return '/assets/images/svg/communication.svg';
    } else if (id === 8) {
        return '/assets/images/svg/financial_expense.svg';
    } else if (id === 9) {
        return '/assets/images/svg/investment.svg';
    } else if (id === 10) {
        return '/assets/images/svg/donation-v3.svg';
    } else if (id === 11) {
        return '/assets/images/svg/education_learning.svg';
    } else if (id === 12) {
        return '/assets/images/svg/groceries.svg';
    } else if (id === 22) {
        return '/assets/images/svg/category/22_v1.svg';
    } else if (id === 23) {
        return '/assets/images/svg/category/23.svg';
    } else if (id === 13) {
        return '/assets/images/svg/category/13.svg';
    } else if (id === 14) {
        return '/assets/images/svg/other_expense_v2.svg';
    } else if (id === 15) {
        return '/assets/images/svg/salary.svg';
    } else if (id === 16) {
        return '/assets/images/svg/sale.svg';
    } else if (id === 17) {
        return '/assets/images/svg/refund.svg';
    } else if (id === 18) {
        return '/assets/images/svg/gifts.svg';
    } else if (id === 19) {
        return '/assets/images/svg/other_income.svg';
    } else if (id === 20) {
        return '/assets/images/svg/lending-v2.svg';
    } else if (id === 21) {
        return '/assets/images/svg/borrow-v2.svg';
    } else if (id === 24) {
        return '/assets/images/svg/charity-donation-svgrepo-com.svg';
    } else if (id === 25) {
        return '/assets/images/svg/category/interest-svgrepo-com.svg';
    } else if (id === 26) {
        return '/assets/images/svg/category/bonus.svg';
    } else if (id === 27) {
        return '/assets/images/svg/category/27.svg';
    } else if (id === 28) {
        return '/assets/images/svg/category/28.svg';
    } else if (id === 29) {
        return '/assets/images/svg/category/29.svg';
    }
};

const getAccountImage = (id, name) => {
    const val = id % 5;
    if (name === 'Cash') {
        return '/assets/images/svg/cashs.svg';
    }
    if (id === 1) {
        return '/assets/images/svg/cashs.svg';
    } else if (val === 2) {
        return '/assets/images/svg/b-account.svg';
    } else if (val === 3) {
        return '/assets/images/svg/account-3.svg';
    } else if (val === 4) {
        return '/assets/images/svg/account-4.svg';
    } else if (val === 1) {
        return '/assets/images/svg/account-6.svg';
    }

    return '/assets/images/svg/default.svg';
};

const formatDate = (dateString) => {
    const options = { day: 'numeric', month: 'long', year: '2-digit' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
};

export { getTransactionClass, getTransactionImage, getAccountImage, formatDate };
